<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="stockinout" />
        <MenuStockList/>
        <AddLotinPoList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import AddLotinPoList from '@/components/menuadmin/stock/stocklist/AddLotinPoList.vue'

export default {
    name:'addLotinPo',
    components:{
        HeaderStock,
        MenuStockList,
        AddLotinPoList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>